import { PrescriberCrosswalkService } from '@/services/pa/prescriber-crosswalk.service';

import { PA_SAVE_PRESCRIBER_CROSSWALK, PA_GET_PRESCRIBER_CROSSWALK, PA_SEARCH_PRESCRIBER_CROSSWALK, PA_DELETE_PRESCRIBER_CROSSWALK } from './actions.type';
import { SET_PA_GET_PRESCRIBER_CROSSWALK_COMPLETE, SET_PA_SEARCH_PRESCRIBER_CROSSWALK_COMPLETE, SET_PA_PRESCRIBER_CROSSWALK_BUSY } from './mutations.type';
import { ERROR_HANDLE_ERROR, ERROR_CLEAR_ERROR } from '../error/actions.type';

const initialState = {
    isBusy: false,
    currentPrescriberCrosswalk: '',
    searchResults: []
};

export const state = Object.assign({}, initialState);

export const actions = {
    [PA_SAVE_PRESCRIBER_CROSSWALK](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, true);
        var promise = null;
        if (body.crosswalk_id) {
            promise = PrescriberCrosswalkService.put(body);
        } else {
            promise = PrescriberCrosswalkService.post(body);
        }
        promise.then((data) => {
            context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            }
            return data;
        },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
            });

        return promise;
    },
    [PA_DELETE_PRESCRIBER_CROSSWALK](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, true);
        return PrescriberCrosswalkService.delete(body).then((data) => {
            context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            }
            return data;
        },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
            });
    },
    [PA_GET_PRESCRIBER_CROSSWALK](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, true);
        return PrescriberCrosswalkService.get(body.prescriber_npi, body.crosswalk_id)
            .then((data) => {
                context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_PA_GET_PRESCRIBER_CROSSWALK_COMPLETE, data);
                }
                return data;
            },
                (err) => {
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                    context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
                });
    },
    [PA_SEARCH_PRESCRIBER_CROSSWALK](context, criteria) {
        context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, true);
        var promise = null;

        promise = PrescriberCrosswalkService.search(criteria);
        promise.then((data) => {
            context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            } else {
                context.commit(SET_PA_SEARCH_PRESCRIBER_CROSSWALK_COMPLETE, data);
            }
            return data;
        },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_PRESCRIBER_CROSSWALK_BUSY, false);
            });

        return promise;
    }
};

const getters = {};

export const mutations = {
    [SET_PA_GET_PRESCRIBER_CROSSWALK_COMPLETE](state, results) {
        state.currentPrescriberCrosswalk = results;
    },
    [SET_PA_SEARCH_PRESCRIBER_CROSSWALK_COMPLETE](state, results) {
        state.searchResults = results;
    },
    [SET_PA_PRESCRIBER_CROSSWALK_BUSY](state, results) {
        state.isBusy = results;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/prescriber-crosswalk/prescriber-crosswalk.module.js